/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
const o=3,t=3,c=10;export{c as pathNumCircleProfileSubdivisions,t as pathNumRoundCapExtrusionSubdivisions,o as pathNumRoundJoinSubdivisions};
